import { useAuth } from "@/context/AuthContext";

/** Saved homes for the signed-in buyer (saving asks visitors to create an account). */
export function useFavorites() {
  const { saved, toggleSaved } = useAuth();
  return { saved, isSaved: (k) => saved.includes(k), toggle: toggleSaved };
}
